module.exports = __webpack_public_path__ + "assets/img/under_review.7d8d11ff.png";